import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddSubUserComponent } from './add-sub-user/add-sub-user.component';
import { ListSubUserComponent } from './list-sub-user/list-sub-user.component';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseWidgetModule } from '@fuse/components';
import { AddSubUserService } from './add-sub-user/add-sub-user.service';
import { NgxFileDropModule } from 'ngx-file-drop';
import { ListSubUserService } from './list-sub-user/list-sub-user.service';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: '', component: ListSubUserComponent,
    resolve: {
      data: ListSubUserService
    }
  },
  {
    path: 'add', component: AddSubUserComponent,
    resolve: {
      data: AddSubUserService
    }
  },
  {
    path: 'edit/:id', component: AddSubUserComponent, resolve: {
      data: AddSubUserService
    }
  },
]

@NgModule({
  declarations: [AddSubUserComponent, ListSubUserComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    MatCardModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatPaginatorModule,
    MatRippleModule,
    MatSelectModule,
    MatSnackBarModule,
    MatTableModule,
    MatDatepickerModule,
    FuseSharedModule,
    FuseWidgetModule,
    MatDialogModule,
    MatGridListModule,
    MatRadioModule,
    NgxFileDropModule
  ]
})
export class SubUserModule { }
